import { oz } from '@vy/utils';
import type { Control } from 'react-hook-form';

export const PaddleConfigurationFormSchema = oz.object({
  apiToken: oz.string(),
  environment: oz.enum(['sandbox', 'production']),
  autoExportInvoices: oz.boolean().optional(),
});

export type PaddleConfigurationFormValues = oz.infer<typeof PaddleConfigurationFormSchema>;
export type PaddleConfigurationControl = Control<PaddleConfigurationFormValues>;
